import { render, staticRenderFns } from "./remindcharts.vue?vue&type=template&id=72432016&scoped=true&"
import script from "./remindcharts.vue?vue&type=script&lang=js&"
export * from "./remindcharts.vue?vue&type=script&lang=js&"
import style0 from "./remindcharts.vue?vue&type=style&index=0&id=72432016&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72432016",
  null
  
)

export default component.exports